import React from "react";
import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { getGroupDisplayName } from "../../../services/training/getGroupDisplayName";

export default function SelectSpecialityGroup(props) {
  const {
    name,
    label,
    value,
    error = null,
    onChange,
    options,
    disabled,
    studyPay,
    typeTraining,
    ...rest
  } = props;

  const visibleOptions = Array.isArray(options)
    ? options
        .map((item) => ({
          item,
          displayName: getGroupDisplayName(item.data, studyPay, typeTraining),
        }))
        .filter(({ displayName }) => displayName !== null)
    : [];
  const hasValueInOptions = visibleOptions.some(({item}) => item?.id === value?.id);
  const selectValue = hasValueInOptions ? value : '';

  return (
    <FormControl
      variant="outlined"
      disabled={disabled}
      fullWidth={rest.fullWidth ? rest.fullWidth : false}
      {...(error && { error: true })}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        autoWidth={true}
        label={label}
        name={name}
        value={selectValue}
        onChange={onChange}
      >
        {visibleOptions.length > 0 ? (
          visibleOptions.map(({ item, displayName }) => (
            <MenuItem
              key={item.id}
              value={item}
              style={{ whiteSpace: "normal" }}
            >
              {displayName}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled={true} value={""}>
            Данные отсутствуют
          </MenuItem>
        )}
      </MuiSelect>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
